import { render } from "./productData.vue?vue&type=template&id=013ddcac&scoped=true"
import script from "./productData.vue?vue&type=script&lang=js"
export * from "./productData.vue?vue&type=script&lang=js"

import "./productData.vue?vue&type=style&index=0&id=013ddcac&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013ddcac"]])

export default __exports__